// extracted by css-extract-rspack-plugin
export default {"copyButton":"lk8XZftXiwZbU0kX"};